import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  FAMILY_MEMBER_TABLE_HEAD,
  SORT_LABELS,
  TABS_LABEL,
} from './constants/family-member-management.constants';
import { CamService } from 'src/app/services/camService/cam.service';
import { Router } from '@angular/router';
import { MatTabChangeEvent, MatTabGroup, MatTab } from '@angular/material/tabs';
import { jwtDecode } from 'jwt-decode';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { NgFor, NgIf, NgClass, DatePipe, KeyValuePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { MatButton } from '@angular/material/button';
import { DependentDatalayerService } from 'src/app/services/dataLayer/CAM/dependent.service';
import { Subject, takeUntil } from 'rxjs';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { ContentService } from '../../services/content.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { ApprovalContentService } from '../../services/approval-content.service';
import { PolicyContentService } from '../../services/policy-content.service';
import { HeaderFooterContentService } from 'src/app/services/headerFooterContentService/header-footer-content.service';

@Component({
  selector: 'app-family-member-management',
  templateUrl: './family-member-management.component.html',
  styleUrls: ['./family-member-management.component.scss'],
  imports: [MatTabGroup, NgFor, MatTab, MatIcon, MatFormField, MatSelect, MatOption, MatSuffix, NgIf, NgClass, CamEmptyStateComponent, MatButton, DatePipe, KeyValuePipe]
})
export class FamilyMemberManagementComponent implements OnInit {
  title: string = 'Family Member Management';
  tableHead = FAMILY_MEMBER_TABLE_HEAD;
  // sortLabels = SORT_LABELS;
  sortLabels: any[] = [];
  tabLabels = TABS_LABEL;
  selected = 'Newest';
  activeTab: number = 0;
  modellRef!: MatDialogRef<any>;
  filteredData: any[] = [];
  filteredGroups: any[] = [];
  searchQuery: string = '';
  dataSources: any;
  currentSource: any;
  travellerList: any[] = [];
  selectedTab: any = 'Requests received';
  user: any;
  pageSize = 20;
  currentPage = 0;
  paginatedData: any[] = [];
  selectedTabIndex: any = 0;
  private readonly destroy$ = new Subject<void>();
  content:any;
  dictionaryContent:any;
  manageTravelerContent:any;
  policyContent:any;
  approvalContent:any;
  headerContent:any;
  constructor(private readonly _MatDialog: MatDialog, private readonly _CamApiService: CamService, private readonly router: Router, private readonly _ToastrApiService: ToastrApiService, private readonly travelerManagement: TravelerManagement, 
    private readonly _DependentDatalayer: DependentDatalayerService,
    private readonly dictionaryContentService: DisctionaryContent,
    private readonly manageTravelercontentService: ContentService,
    private readonly contentService: CompanyManagementContentService,
    private readonly approvalContentService: ApprovalContentService,
    private readonly policyContentService:PolicyContentService,
    private readonly headercontentService: HeaderFooterContentService,
  ) {
    this.user = this.getUserFromToken();
    this.selectedTabIndex = sessionStorage.getItem('selectedTab');
    if (this.selectedTabIndex == 1) {
      this.selectedTab = 'View sent invites';
      this.getOwnDependent();
    } else {
      this.selectedTab = 'Requests received';
      this.getAllDependent();
    }
  }

  ngOnInit() {
     this.headercontentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.headerContent = res;
    });
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = res;
    });
    this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.dictionaryContent = res;
    });
    this.manageTravelercontentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.manageTravelerContent = res;
    });
    this.approvalContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.approvalContent = res;
       this.sortLabels = res?.['b2b.manageapproval.filterlist'] || [];
    });
    this.policyContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.policyContent = res;
    });
    // this.getAllDependent();
    this.getAllTraveler();
  }
  private getUserFromToken() {
    const token = localStorage.getItem('QlAccessToken');
    if (!token) return null;

    const decoded: any = jwtDecode(token);
    return {
      subAgentId: decoded?.subAgentId,
      userId: decoded?.userId,
      uid: decoded?.uid,
      role: decoded?.role
    };
  }
  onTabChange(event: MatTabChangeEvent) {
    console.log('tab event dsad ', event);
    this.selectedTabIndex = event?.index;
    this.selectedTab = event?.tab?.textLabel;
    sessionStorage.setItem('selectedTabName', this.selectedTab);
    if (event?.tab?.textLabel == 'View sent invites') {
      this.getOwnDependent();
      this._DependentDatalayer.familyManagementTab('view sent invites click', 'view sent invites', 'view sent invites');
    } else {
      this.getAllDependent();
      this._DependentDatalayer.familyManagementTab('requests received click', 'requests received', 'requests received');
    }
  }
  updatePaginatedData() {

    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedData = this.filteredData.slice(startIndex, endIndex);
    console.log('update pagination called');
  }
  getAllTraveler() {
    const user = this.user;
    const payload = {
      subagentId: user.subAgentId,
      userRole: user.role,
      b2BUserId: user.userId
    };

    const searchParam = '';
    this._CamApiService.getManagerList(user.subAgentId, user.uid, searchParam, payload).then((res: any) => {
      this.travellerList = res?.data?.managers;
      this.groupByFirstLetter();
    })
  }
  getAllDependent() {
    this._CamApiService
      .getDependentForAdmin(1)
      .then((response: any) => {
        if (response?.status === 'Success') {
          this.filteredData = [];
          this.dataSources = response.data;
          this.filteredData = this.dataSources;
          const savedPage = sessionStorage.getItem('returnPage');
          if (savedPage !== null) {
            this.currentPage = Number(savedPage);
            // one-time use
            sessionStorage.removeItem('returnPage');
          }
          else {
            this.currentPage = 0;
          }
          this.updatePaginatedData();
        }
        console.log('sources data ', this.currentSource)
      })
      .catch((error: any) => {
        if (error?.error?.message == 'No response from stored procedure') {
          this.filteredData = [];
          this.updatePaginatedData();
        }
      });
  }
  getOwnDependent() {
    this._CamApiService
      .getDependentForAdmin('') //change for admin getDependentForAdmin(2)
      .then((response: any) => {
        if (response?.status === 'Success') {
          this.filteredData = [];
          this.dataSources = response.data;
          this.filteredData = this.dataSources;
          const savedPage = sessionStorage.getItem('returnPage');
          if (savedPage !== null) {
            this.currentPage = Number(savedPage);
            // one-time use
            sessionStorage.removeItem('returnPage');
          }
          else {
            this.currentPage = 0;
          }
          this.updatePaginatedData();
        }
      })
      .catch((error: any) => {
        if (error?.error?.message == 'No response from stored procedure') {
          this.filteredData = [];
          this.updatePaginatedData();
        }
      });
  }
  get totalPages(): number {
    return Math.ceil(this.filteredData.length / this.pageSize);
  }

  nextPage() {
    if ((this.currentPage + 1) < this.totalPages) {
      this.currentPage++;
      this.updatePaginatedData();
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.updatePaginatedData();
    }
  }
  searchFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    console.log('filter value');
    if (!filterValue) {
      this.filteredData = this.dataSources;
    } else {
      this.filteredData = this.dataSources.filter((data: any) => {
        return (
          data?.dependantId?.toString().includes(filterValue) ||
          data?.dependantName?.toLowerCase().includes(filterValue) ||
          data?.dependantEmail?.toLowerCase().includes(filterValue) ||
          data?.employee_Code?.toLowerCase().includes(filterValue)
        );
      });
    }
    this.sortData(this.selected);
    this.currentPage = 0; // reset page
    this.updatePaginatedData();
  }
  searchTravelerFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    console.log('filter value ', filterValue);
    if (!filterValue) {
      this.filteredGroups = this.travellerList;
      this.groupByFirstLetter();
    } else {
      let filterdData: any[] = [];
      filterdData = this.travellerList.filter((data: any) => {
        return (
          data?.userName?.toLowerCase().includes(filterValue) ||
          data?.emailAddress?.toLowerCase().includes(filterValue)
        );
      });
      this.filteredGroups = filterdData.reduce((acc: any, emp: any) => {
        const letter = emp.userName.charAt(0).toUpperCase();
        if (!acc[letter]) {
          acc[letter] = [];
        }
        acc[letter].push(emp);
        return acc;
      }, {});
      console.log('filtergroup data ', this.filteredGroups)
    }
  }

  closeModal() {
    this.modellRef.close();
    this.filteredGroups = this.travellerList;
    this.groupByFirstLetter();
  }
  groupByFirstLetter() {
    this.filteredGroups = this.travellerList.reduce((acc: any, emp: any) => {
      const letter = emp.userName.charAt(0).toUpperCase();
      if (!acc[letter]) {
        acc[letter] = [];
      }
      acc[letter].push(emp);
      return acc;
    }, {});
  }

  hasData(): boolean {
    if (!this.filteredGroups) return false;

    return Object.values(this.filteredGroups).some(
      (group: any) => group && group.length > 0
    );
  }

  sortBy() {
    // call GTM event
    const noOfResult = this.filteredData?.length || 0;
    this.travelerManagement.family_management_click(noOfResult, 'Sort');
    this._DependentDatalayer.familyManagement('Sort Click', 'sortby', 'Sort by');
  }

  sortData(criteria: string) {
    //call the event of dependent sort
    // call GTM event
    const noOfResult = this.filteredData?.length || 0;
    this.travelerManagement.family_management_click(noOfResult, 'Sort');
    this._DependentDatalayer.familyManagement(`${criteria} Click`, `${criteria}_Sort`, `${criteria}`,);
    console.log('sort by', criteria);
    this.selected = criteria;
    switch (criteria) {
      case 'newest':
        this.paginatedData.sort((a, b) => new Date(b.requestDate).getTime() - new Date(a.requestDate).getTime());
        break;
      case 'oldest':
        this.paginatedData.sort((a, b) => new Date(a.requestDate).getTime() - new Date(b.requestDate).getTime());
        break;
      case 'a-z':
        this.paginatedData.sort((a, b) => a.employeeName.localeCompare(b.employeeName));
        break;
      case 'z-a':
        this.paginatedData.sort((a, b) => b.employeeName.localeCompare(a.employeeName));
        break;
    }
  }

  openModal(template: TemplateRef<any>) {
    //call the event of add dependent
    const noOfResult = this.filteredData?.length;
    this.travelerManagement.family_management_click(noOfResult, 'Add Dependent');
    this._DependentDatalayer.newFamilyDependent('Requests recieved', 'Add Dependent', 'add dependents', noOfResult);

    this.modellRef = this._MatDialog.open(template, {
      panelClass: ['custom-popup-gen-policy-filter-popup', 'translate-none', 'modal-mob'],
      disableClose: false,
      autoFocus: false
    });
    this._DependentDatalayer.newFamilyDependentEmployee('Requests recieved', 'PopUp_view', 'Popup_pageview');
    this.modellRef.afterClosed().subscribe((res: any) => {
      this.filteredGroups = this.travellerList;
      this.groupByFirstLetter();
    })
  }
  reviewDependent(data: any) {
    sessionStorage.setItem(
      'returnPage',
      this.currentPage.toString()
    );
    sessionStorage.setItem('selectedTab', this.selectedTabIndex);
    //call the event of dependent review
    const noOfResult = this.filteredData?.length || 0;
    this.travelerManagement.family_management_click(noOfResult, 'Review');
    this._DependentDatalayer.dependentRequestReveiew('Requests received', 'Review')
    console.log('dependent data ', data);
    sessionStorage.setItem('dptState', '3');
    this.router.navigate(['/cam/saved-dependents/dependent-information-form'], {
      queryParams: {
        dependentId: data?.dependantId.toString(),
        userId: data?.b2bUserId
      }
    })
  }
  async resendInvite(dependent: any) {
    //call the event of dependent resend
    const noOfResult = this.filteredData?.length || 0;
    this.travelerManagement.family_management_click(noOfResult, 'Resend Invite');
    this._DependentDatalayer.resendDependent('View sent invites', 'Resend click', 'Resend');
    const payload = {
      email: dependent?.dependantEmail,
      b2bUserGuid: dependent?.guid
    }
    try {
      const response = await this._CamApiService.generateDependentToken(payload);
      if (response?.status === 'Created' || response?.status === 'Success') {
        this._ToastrApiService.show(
          'success',
          'Invite sent again to the dependent successfully.'
        );
      } else {
        this._ToastrApiService.show(
          'error',
          response?.message || 'Failed to resent invite.'
        );
      }
    } catch (error: any) {
      const message =
        error?.error?.message || error?.message ||
        'Something went wrong while creating token. Please try again.';
      this._ToastrApiService.show('error', message);
    }
  }
  viewInvite(dependent: any) {
    this._DependentDatalayer.viewDependent('View sent invites', 'View click', 'View');
    sessionStorage.setItem(
      'returnPage',
      this.currentPage.toString()
    );
    sessionStorage.setItem('selectedTab', this.selectedTabIndex);
    sessionStorage.setItem('dptState', '2');
    this.router.navigate(['/cam/saved-dependents/dependent-information-form'], {
      queryParams: {
        dependentId: dependent?.dependantId,
        userId: dependent?.b2bUserId
      }
    });
  }
  handleEvent(event: string) { }
  addDependentFor(arrangerId: any) {
    this._DependentDatalayer.newFamilyDependentEmployee('Requests recieved', 'CTA Click', 'view');
    this.modellRef.close();
    sessionStorage.setItem('dptState', '1');
    sessionStorage.setItem('userId', arrangerId?.b2BUserId)
    this.router.navigate(['/cam/saved-dependents/dependent-information-form'], {
      queryParams: {
        traveller: arrangerId?.b2BUserGuid
      }
    });
  }
  
}